import { postRequest, getRequest } from './apiService';
import { API_BASE_URL } from '../config/config';

/**
 * Posts a note to the InsureAI intake API with application ID and page number.
 *
 * @param {Object} noteData - The complete note payload including application ID and page number.
 * @param {string} accessToken - The JWT access token.
 * @param {string} refreshToken - The JWT refresh token.
 * @returns {Promise<Object>} - The response from the API.
 */
export async function postNoteWithApplicationId (
  noteData,
  accessToken,
  refreshToken
) {
  const url = `${API_BASE_URL}/insureai/ml/intake/applications/v2/notes/`;

  const headers = {
    accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken
  };

  try {
    const response = await postRequest(url, noteData, headers);
    return response;
  } catch (error) {
    console.error('Error posting note with application ID:', error);
    throw error;
  }
}

/**
 * Fetches notes from the InsureAI intake API using the application ID.
 *
 * @param {string} applicationId - The ID of the application to fetch notes for.
 * @param {string} accessToken - The JWT access token.
 * @param {string} refreshToken - The JWT refresh token.
 * @returns {Promise<Object>} - The response data containing notes.
 */
export async function getNotesByApplicationId (
  applicationId,
  accessToken,
  refreshToken
) {
  const baseUrl = `${API_BASE_URL}/insureai/ml/intake/applications/v2/notes/`;
  const url = `${baseUrl}?application_id=${encodeURIComponent(applicationId)}`;

  const headers = {
    accept: 'application/json',
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken
  };

  try {
    const response = await getRequest(url, headers);
    return response;
  } catch (error) {
    console.error('Error fetching notes by application ID:', error);
    throw error;
  }
}
